import { Input, Label } from '@/shared/ui/primitives'
import { cn } from '@/shared/ui/cn'
import { NumberInput, type NumberInputMode } from './number-input'

type FormInputProps = {
  id: string
  label: string
  value: string
  onChange: (value: string) => void
  onBlur?: () => void
  error?: string
  required?: boolean
  type?: 'text' | 'email' | 'number'
  numericMode?: NumberInputMode
  placeholder?: string
  disabled?: boolean
  maxLength?: number
  autoCapitalize?: 'none' | 'sentences' | 'words' | 'characters'
  className?: string
}

function FormInput({
  id,
  label,
  value,
  onChange,
  onBlur,
  error,
  required,
  type,
  numericMode,
  placeholder,
  disabled,
  maxLength,
  autoCapitalize,
  className,
}: FormInputProps) {
  return (
    <div className={cn('grid gap-2', className)}>
      <Label htmlFor={id}>
        {label}
        {required ? ' *' : null}
      </Label>
      {numericMode ? (
        <NumberInput
          id={id}
          mode={numericMode}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          disabled={disabled}
          aria-invalid={!!error}
          aria-describedby={error ? `${id}-error` : undefined}
        />
      ) : (
        <Input
          id={id}
          type={type ?? 'text'}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          onBlur={onBlur}
          placeholder={placeholder}
          disabled={disabled}
          maxLength={maxLength}
          autoCapitalize={autoCapitalize}
          autoCorrect={autoCapitalize === 'none' ? 'off' : undefined}
          spellCheck={autoCapitalize === 'none' ? false : undefined}
          aria-invalid={!!error}
          aria-describedby={error ? `${id}-error` : undefined}
        />
      )}
      {error ? (
        <p id={`${id}-error`} className="text-sm text-destructive">
          {error}
        </p>
      ) : null}
    </div>
  )
}

export { FormInput }
export type { FormInputProps }
